import { ViperDatePicker } from "@/components";
import dayjs from "dayjs";
import { bool, object } from "prop-types";
import { useState } from "react";
import { useIntl } from "react-intl";
import { DynamicFormItem } from "./DynamicFormItem";
import { getPlaceholderText } from "./helper/getPlaceholderText";
import { useCheckEditableFormField } from "./hooks/useCheckEditableFormField";

export const DynamicDatePicker = ({
  formField,
  formField: { startDateValidationField, endDateValidationField, property },
  formDisabled,
}) => {
  const intl = useIntl();
  const [startDate, setStartDate] = useState(null);
  const [endDate, setEndDate] = useState(null);
  const { isDisabled, formRef } = useCheckEditableFormField(formField);
  const getValueProps = (value) => {
    if (value) {
      return { value: dayjs(value) };
    }
    return { value: value };
  };

  const focus = () => {
    if (formRef.current) {
      if (startDateValidationField) {
        const startDateFieldValue = formRef.current.getFieldValue(
          property.startDateValidationField
        );
        setStartDate(dayjs(startDateFieldValue).startOf("day"));
      }
      if (endDateValidationField) {
        const endDateFieldValue = formRef.current.getFieldValue(
          property.endDateValidationField
        );
        setEndDate(dayjs(endDateFieldValue).startOf("day").add(1, "days"));
      }
    }
  };

  const disabledDate = (current) => {
    let enabled = true;

    if (startDate) enabled = current >= startDate;

    if (endDate) enabled = current <= endDate;

    return !enabled;
  };
  return (
    <DynamicFormItem formFieldProperty={property} getValueProps={getValueProps}>
      <ViperDatePicker
        id={`dynamic-date-picker-${property.name}`}
        disabled={isDisabled || formDisabled}
        disabledDate={disabledDate}
        onFocus={focus}
        placeholder={
          getPlaceholderText(formDisabled, formField, intl) || undefined
        }
      />
    </DynamicFormItem>
  );
};

DynamicDatePicker.propTypes = {
  formField: object.isRequired,
  formDisabled: bool,
};
